module.exports = __webpack_public_path__ + "img/img2.7ff237b2.jpg";